var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98745 3.56596C4.76161 3.81577 4.76161 4.19048 4.98745 4.4153L8.40025 7.81265C8.65119 8.06245 9.0276 8.06245 9.25345 7.81265L9.83061 7.26308C10.0565 7.01327 10.0565 6.63856 9.83061 6.41374L7.39649 3.99063L9.83061 1.59251C10.0565 1.36768 10.0565 0.967994 9.83061 0.743169L9.25345 0.168618C9.0276 -0.0562061 8.65119 -0.0562061 8.40025 0.168618L4.98745 3.56596ZM0.169385 4.4153L3.58218 7.81265C3.83312 8.06245 4.20954 8.06245 4.43538 7.81265L5.01255 7.26308C5.23839 7.01327 5.23839 6.63856 5.01255 6.41374L2.57842 3.99063L5.01255 1.59251C5.23839 1.36768 5.23839 0.967994 5.01255 0.743169L4.43538 0.168618C4.20954 -0.0562061 3.83312 -0.0562061 3.58218 0.168618L0.169385 3.56596C-0.0564617 3.81577 -0.0564617 4.19048 0.169385 4.4153Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackAll);
export default __webpack_public_path__ + "static/media/back-all.f655b1a4f0afd7cd3bd1ac70f6af1fa7.svg";
export { ForwardRef as ReactComponent };